import { FieldType } from '@widgets/EnquiryForm/types/config';
const checkboxTypes = [FieldType.CheckboxInput];
const generateDefaultValues = (fields) => (fields ?? []).reduce((prev, curr) => {
    let formattedNext = {};
    if (curr.type === FieldType.HTMLContent) {
        return Object.assign(prev, formattedNext);
    }
    if (checkboxTypes.includes(curr.type)) {
        const defaultValues = (curr.options ?? [])
            .map(({ defaultState, value }) => (defaultState ? value : false))
            .filter(Boolean);
        formattedNext = {
            [`${curr.name}`]: defaultValues,
        };
    }
    else {
        formattedNext = {
            [`${curr.name}`]: curr.defaultValue,
        };
    }
    return Object.assign(prev, formattedNext);
}, {});
export default generateDefaultValues;
